import { EMPTY_ARRAY, EMPTY_OBJECT } from '#pplx/frontend/common/defaults.js';
import { applyPatch } from 'fast-json-patch';
// Keep prior React snapshots intact without cloning untouched workflow history.
export function applyPatchWithStructuralSharing(document, patches) {
    let result = document;
    const owned = new WeakSet();
    const writable = (value) => {
        if (value === null || typeof value !== 'object' || owned.has(value))
            return value;
        const copy = Array.isArray(value) ? value.slice() : { ...value };
        owned.add(copy);
        return copy;
    };
    const preparePath = (path) => {
        result = writable(result);
        let parent = result;
        for (const token of path.split('/').slice(1, -1)) {
            const key = token.replace(/~1/g, '/').replace(/~0/g, '~');
            // Only traverse JSON-owned values; inherited objects must never be copied or changed.
            if (key === '__proto__' || !Object.hasOwn(parent, key)) {
                throw new TypeError('Unsafe JSON Patch path');
            }
            parent[key] = writable(parent[key]);
            parent = parent[key];
        }
    };
    for (const operation of patches) {
        // `move` removes its source before resolving the destination. An array
        // removal can therefore shift a different, still-shared object into the
        // destination path, so fall back to the library's immutable application.
        if (operation.op === 'move') {
            result = applyPatch(result, [operation], false, false).newDocument;
            continue;
        }
        if (operation.op !== 'test') {
            preparePath(operation.path);
        }
        result = applyPatch(result, [operation], false, true).newDocument;
    }
    return result;
}
export function mergeBlocksWithDiffBlocks(existingBlocks, responseBlocks) {
    const blocks = new Map(existingBlocks.map((block) => [block.intended_usage, block]));
    for (const block of responseBlocks) {
        if (block.diff_block) {
            const field = block.diff_block.field;
            const existingValue = blocks.get(block.intended_usage)?.[field] ?? EMPTY_OBJECT;
            const patches = block.diff_block.patches ?? EMPTY_ARRAY;
            const newValue = applyPatchWithStructuralSharing(existingValue, patches);
            blocks.set(block.intended_usage, {
                intended_usage: block.intended_usage,
                [field]: newValue,
            });
        }
        else {
            blocks.set(block.intended_usage, block);
        }
    }
    return Array.from(blocks.values());
}
//# sourceMappingURL=dataTransformation.js.map